import { IActionType } from '../../../common/common.types'
import { FormFactorConstants } from '../../../common/formFactor.constants'
import { getFormFactor } from '../../../utilities'
import { getOrSetValueFromNotation } from '../../../utilities'
import { ValidationConstants } from '../store/validation.constants'
import { InputValidationInputs } from '../store/validation.types'

export const buildInputValidationId = (setActionType: string, cardinalityKey?: string): string => {
  const formFactor = getFormFactor()
  return buildInputValidationIdInternal(setActionType, formFactor, cardinalityKey)
}

export const buildInputValidationIdForMobile = (setActionType: string, cardinalityKey?: string): string => {
  return buildInputValidationIdInternal(setActionType, FormFactorConstants.MOBILE, cardinalityKey)
}

export const buildInputValidationIdForTablet = (setActionType: string, cardinalityKey?: string): string => {
  return buildInputValidationIdInternal(setActionType, FormFactorConstants.TABLET, cardinalityKey)
}

const buildInputValidationIdInternal = (setActionType: string, formFactor: string, cardinalityKey?: string): string => {
  return `${setActionType}/${cardinalityKey ? cardinalityKey : 'null'}/${formFactor}`
}

export const buildInputValidationInputs = (action: IActionType | any): InputValidationInputs => {
  let value = ''
  let cardinalityKey = ''
  let prop = ''
  let conditionalValue = ''

  Object.keys(action).forEach((key) => {
    if (key != 'type' && typeof action[key] != 'object' && key !== ValidationConstants.CONDITIONAL_VALUE) {
      prop = key
      value = getOrSetValueFromNotation(action, prop)
    }
    if (typeof action[key] === 'object') {
      cardinalityKey = action[key]?.key
    }
    if (key === ValidationConstants.CONDITIONAL_VALUE) {
      conditionalValue = getOrSetValueFromNotation(action, key)
    }
  })

  return {
    action: action.type,
    value,
    cardinalityKey,
    conditionalValue,
  }
}
